// Classes
import { ProspectProfileReducerState } from "Containers/Filter/ProspectProfile/classes/prospectProfile.classes";
import { AttributeObject } from "../classes/attributes.classes";

/**
 * @function getTestScoresAttributes
 *
 * Post-processes the attributes for this section of the filter
 *
 * @param {ProspectProfileReducerState} prospectProfile - The current state
 * of the Prospect Profile filter section.
 * @return {AttributeObject | undefined}
 *
 * @example
 *
 *     getTestScoresAttributes(prospectProfile)
 */
export const getTestScoresAttributes = (
  prospectProfile: ProspectProfileReducerState
) => {
  let attributeObject = undefined;
  let attributeArray = [];

  switch (prospectProfile.testScores.selection) {
    case "SAT":
      attributeArray.push(
        `SAT = ${prospectProfile.testScores.value.sat.lower} - ${prospectProfile.testScores.value.sat.upper}`
      );
      attributeObject = new AttributeObject("SAT", "standard", attributeArray);
      break;
    case "ACT":
      attributeArray.push(
        `ACT = ${prospectProfile.testScores.value.act.lower} - ${prospectProfile.testScores.value.act.upper}`
      );
      attributeObject = new AttributeObject("ACT", "standard", attributeArray);
      break;
    case "SAT or ACT":
    case "SAT and ACT":
      attributeArray.push(
        `SAT = ${prospectProfile.testScores.value.sat.lower} - ${prospectProfile.testScores.value.sat.upper}`,
        `ACT = ${prospectProfile.testScores.value.act.lower} - ${prospectProfile.testScores.value.act.upper}`
      );
      attributeObject = new AttributeObject(
        prospectProfile.testScores.selection,
        "standard",
        attributeArray
      );
      break;
  }

  return attributeObject;
};
try {
    // @ts-ignore
    getTestScoresAttributes.displayName = "getTestScoresAttributes";
    // @ts-ignore
    getTestScoresAttributes.__docgenInfo = { "description": "", "displayName": "getTestScoresAttributes", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Attributes/utilities/getTestScoresAttributes.ts#getTestScoresAttributes"] = { docgenInfo: getTestScoresAttributes.__docgenInfo, name: "getTestScoresAttributes", path: "src/shared/containers/Attributes/utilities/getTestScoresAttributes.ts#getTestScoresAttributes" };
}
catch (__react_docgen_typescript_loader_error) { }